import {
  DATA_CONTROL_SNACKBAR,
  SET_DATA_CONTROL_CARD_SUMMARY,
  SET_DATA_CONTROL_DASHBOARD_SUMMARY,
  SET_DATA_CONTROL_DOMAIN_FILES_VIEW,
  SET_DATA_CONTROL_FILES_DATA,
  SET_DATA_CONTROL_LOADER,
  SET_DOMAIN_AUDIT_TRAILS,
  SET_FILE_AUDIT_TRAIL,
  SET_REVOKE_FILE_IDS,
  SET_USER_AUDIT_TRAILS,
  SET_USER_LOCATION_AUDIT_TRAIL,
} from "../DataControlConstans";

const initialState = {
  cardSummary: {},
  dashboardSummary: {},
  loader: false,
  dataControlFilesData: {
    summary: {},
    flaggedFiles: [],
  },
  selectedRevokeFileIds: [],
  fileAuditTrail: {
    rows: [],
    total: 0,
    page: 0,
    pageSize: 10,
  },
  userAuditTrail: {
    rows: [],
    total: 0,
    page: 0,
    pageSize: 10,
  },
  domainAuditTrail: {
    rows: [],
    total: 0,
    page: 0,
    pageSize: 10,
  },
  userLocationAuditTrail: {
    rows: [],
    total: 0,
    page: 0,
    pageSize: 10,
  },
  dataControlUserFilesView: [],
  dataControlDomainFilesView: [],
  dataControlSnackbar: {
    success: "",
    successMessage: "",
    failure: "",
    failureMessage: "",
  },
};

export default function dataControlReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA_CONTROL_CARD_SUMMARY:
      return {
        ...state,
        cardSummary: {
          ...state.cardSummary,
          [action.payload.cardName]: action.payload,
        },
      };
    case SET_DATA_CONTROL_DASHBOARD_SUMMARY:
      return {
        ...state,
        dashboardSummary: action.payload,
      };
    case SET_DATA_CONTROL_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_DATA_CONTROL_FILES_DATA:
      return {
        ...state,
        dataControlFilesData: action.payload,
      };
    case SET_REVOKE_FILE_IDS:
      return {
        ...state,
        selectedRevokeFileIds: action.payload,
      };
    case SET_FILE_AUDIT_TRAIL:
      return {
        ...state,
        fileAuditTrail: action.payload,
      };
    case "SET_DATA_CONTROL_USER_FILES_VIEW":
      return {
        ...state,
        dataControlUserFilesView: action.payload,
      }
    case SET_DATA_CONTROL_DOMAIN_FILES_VIEW:
      return {
        ...state,
        dataControlDomainFilesView: action.payload,
      }
    case SET_USER_AUDIT_TRAILS:
      return {
        ...state,
        userAuditTrail: action.payload,
      }
    case SET_DOMAIN_AUDIT_TRAILS:
      return {
        ...state,
        domainAuditTrail: action.payload,
      }
    case DATA_CONTROL_SNACKBAR:
      return {
        ...state,
        dataControlSnackbar: action.payload,
      }
    case SET_USER_LOCATION_AUDIT_TRAIL:
      return {
        ...state,
        userLocationAuditTrail: action.payload,
      }
    default:
      return state;
  }
}
